// extracted by mini-css-extract-plugin
module.exports = {"viewDownloadsModalWrapper":"qb","header":"qc","headline":"qd","closeIcon":"qe","modalCloseIcon":"qf"};